import React, { useEffect } from 'react';
import PartnerHero from '../components/join-partner/PartnerHero';
import PartnerFeatures from '../components/join-partner/PartnerFeatures';
import PartnerBenefits from '../components/join-partner/PartnerBenefits';
import PartnerStories from '../components/join-partner/PartnerStories';
import PartnerSteps from '../components/join-partner/PartnerSteps';
import EarningsCalculator from '../components/join-partner/EarningsCalculator';
import Footer from '../components/Footer';
import './JoinPartner.css';

const JoinPartner = () => {
  useEffect(() => {
    // Update document title
    document.title = 'Join as Partner | Hopmate - Earn ₹40,000-₹80,000 Monthly';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Join Hopmate Partner Program and earn ₹40,000-₹80,000 monthly. Join 1,000+ creators building thriving communities on India\'s fastest-growing voice platform. Apply now!'
      );
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Join as Partner | Hopmate - Earn ₹40,000-₹80,000 Monthly');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute(
        'content',
        'Join Hopmate Partner Program and earn ₹40,000-₹80,000 monthly. Join 1,000+ creators building thriving communities on India\'s fastest-growing voice platform. Apply now!'
      );
    }
    
    // Cleanup function to restore original meta tags when component unmounts
    return () => {
      document.title = 'Hopmate | Conversational Therapy for Everyone';
      if (metaDescription) {
        metaDescription.setAttribute(
          'content',
          'Hopmate makes conversational therapy services accessible in your city. Speak in your language, find peace of mind.'
        );
      }
      if (ogTitle) {
        ogTitle.setAttribute('content', 'Hopmate | Conversational Therapy for Everyone');
      }
      if (ogDescription) {
        ogDescription.setAttribute(
          'content',
          'Hopmate makes conversational therapy services accessible in your city. Speak in your language, find peace of mind.'
        );
      }
    };
  }, []);

  return (
    <div className="join-partner-page">
      <PartnerHero />
      <PartnerFeatures />
      <PartnerBenefits />
      <PartnerStories />
      <PartnerSteps />
      <EarningsCalculator />
      <Footer />
    </div>
  );
};

export default JoinPartner;

